import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {MaterialStoragesHistory} from '../types'

import {
  materialStorageHistoryQueryOptions,
  MaterialStorageHistoryQueryKey
} from './materialStorageHistoryQueryOptions'

export {MaterialStorageHistoryQueryKey}

type Params<TReturn = MaterialStoragesHistory> = {
  plantId: string
  from: string
  to: string
  options?: Omit<
    UseQueryOptions<MaterialStoragesHistory, AxiosError, TReturn>,
    'queryKey' | 'queryFn'
  >
}

export const useMaterialStorageHistory = <TReturn = MaterialStoragesHistory>({
  plantId,
  from,
  to,
  options
}: Params<TReturn>) =>
  useQuery<MaterialStoragesHistory, AxiosError, TReturn>({
    ...materialStorageHistoryQueryOptions(plantId, from, to),
    ...options
  })
